'use strict';

// @ts-ignore
exports.__esModule = true;
// @ts-ignore
exports.default = {
  el: {
    colorpicker: {
      confirm: 'ठीक है',
      clear: 'हटाएं'
    },
    datepicker: {
      now: 'अभी',
      today: 'आज',
      cancel: 'रद्द',
      clear: 'हटाएं',
      confirm: 'ठीक है',
      selectDate: 'तारीख़ चुनें',
      selectTime: 'समय चुनें',
      startDate: 'आरंभ  तारीख़',
      startTime: 'आरंभ  समय',
      endDate: 'समाप्ति तारीख़',
      endTime: 'समाप्ति समय',
      prevYear: 'पिछला साल',
      nextYear: 'अगला साल',
      prevMonth: 'पिछला महीना',
      nextMonth: 'अगला महीना',
      year: '',
      month1: 'जनवरी',
      month2: 'फ़रवरी',
      month3: 'मार्च',
      month4: 'अप्रैल',
      month5: 'मई',
      month6: 'जून',
      month7: 'जुलाई',
      month8: 'अगस्त',
      month9: 'सितंब',
      month10: 'अक्टूबर',
      month11: 'नवंबर',
      month12: 'दिसंबर',
      // week: 'सप्ताह',
      weeks: {
        sun: 'रवि',
        mon: 'सोम',
        tue: 'मंगल',
        wed: 'बुध',
        thu: 'गुरु',
        fri: 'शुक्र',
        sat: 'शनि'
      },
      months: {
        jan: 'जनवरी',
        feb: 'फ़रवरी',
        mar: 'मार्च',
        apr: 'अप्रैल',
        may: 'मई',
        jun: 'जून',
        jul: 'जुलाई',
        aug: 'अगस्त',
        sep: 'सितंबर',
        oct: 'अक्टूबर',
        nov: 'नवंबर',
        dec: 'दिसंबर'
      }
    },
    select: {
      loading: 'लोड हो रहा है',
      noMatch: 'कोई मेल नहीं मिला',
      noData: 'कोई डेटा उपलब्ध नहीं',
      placeholder: 'चुनें'
    },
    cascader: {
      noMatch: 'कोई मेल नहीं मिला',
      loading: 'लोड हो रहा है',
      placeholder: 'चुनें'
    },
    pagination: {
      goto: 'यहाँ जाएं',
      pagesize: ' पेज पर',
      total: 'कुल {टोटल}',
      pageClassifier: ''
    },
    messagebox: {
      title: 'संदेश',
      confirm: 'ठीक है',
      cancel: 'रद्द',
      error: 'अमान्य इनपुट'
    },
    upload: {
      deleteTip: 'मिटाने के लिए [डिलीट] दबाएं',
      delete: 'मिटाएं',
      preview: 'प्रिव्हिव',
      continue: 'जारी रखें'
    },
    table: {
      emptyText: 'कोई डेटा नहीं',
      confirmFilter: 'पुष्टि करें',
      resetFilter: 'रीसेट करें',
      clearFilter: 'सभी',
      sumText: 'सारांश'
    },
    tree: {
      emptyText: 'कोई डेटा नहीं'
    },
    transfer: {
      noMatch: 'कोई मेल नहीं मिला',
      noData: 'कोई डेटा उपलब्ध नहीं',
      titles: ['सूची 1','सूच 2'],
      filterPlaceholder: 'कीवर्ड डालें',
      noCheckedFormat: '{कुल} अंक',
      hasCheckedFormat: '{चेक किया गया}/{कुल} चुने हुएं'
    }
  }
};